import React from "react";

function Logo(props) {
  return <img src={props.src} alt="" className="icons" />;
}

export default Logo;
